import axios, { AxiosError } from "axios";
import Auth from "../services/auth/AuthService";
import qs from "qs";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { "Content-Type": "application/json" },
});

// api.interceptors.request.use((config) => {
//     config.paramsSerializer = (params) => qs.stringify(params);
//     return config;
// });

api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            Auth.setAuth(undefined);
        }
        const message = error.response?.data as string;
        console.error(message);
        // throw error;
        return error;
    }
);

export default api;
